// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

require("prismjs/themes/prism.css")
//ok: 
//fail:require("prismjs/themes/vs-dark.css")
